import * as React from 'react';
import { Performance } from '../../../classes/performance';
import { IOption } from '../../../classes/seating-option';
import { formatId } from '../../../helpers/string-format';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';

interface IPerformanceSelectProps {
    currentPerformanceId: number;
    productionPerformances: Array<Performance>;
    legend: string;
}

class PerformanceSelect extends React.PureComponent<IPerformanceSelectProps, { selectedPerformanceId: number }>{
    constructor(props: IPerformanceSelectProps) {
        super(props);
        this.state = {
            selectedPerformanceId: props.currentPerformanceId
        };
    }

    render() {
        return (
            <div className="map-level-select-container">
                <div className="map-level-select-wrapper" onClick={(evt) => { this._updateLegendFlyoutState(true) }}>
                    <div className="map-level-select-wrapper-inner">
                        <fieldset>
                            <legend className="visually-hidden">{this.props.legend}</legend>
                            <ul>
                                {
                                    this.props.productionPerformances.map(performance => {
                                        const validId = `r_${formatId(performance.id.toString())}`;
                                        return <li key={performance.id} className="form-item">
                                            <input type="radio" name="performance" value={performance.id} id={validId}
                                                onClick={this._onPerformanceSelect.bind(this)}
                                                defaultChecked={this.state.selectedPerformanceId === performance.id}
                                            />
                                            <label htmlFor={validId}>{performance.dateString}</label>

                                            <div className="venue-level-list-item-info">

                                                <p className="venue-level-list-item-info-prices">
                                                    {performance.timeString}
                                                </p>

                                                {
                                                    performance.performanceNote ?
                                                        <p className="venue-level-list-item-info-seats">
                                                            {performance.performanceNote}
                                                        </p>
                                                        : null
                                                }
                                            </div>


                                        </li>
                                    }, this)
                                }
                            </ul>
                        </fieldset>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * When a new radio button is selected, update the state appropriately.
     */
    _onPerformanceSelect = (element) => {
        const performanceId = element.currentTarget.value;
        this.setState({
            selectedPerformanceId: performanceId
        });

        const newQuery = `itemNumber=${performanceId}`

        if (performanceId !== undefined) {
            window.location.search = newQuery;
        }
    };

    _updateLegendFlyoutState = (flyoutStatus) => {
        const newState = {
            ...this.state,
            isFlyout: flyoutStatus
        };

        this.setState(newState as any);
    };
}

export default PerformanceSelect;